<template>
  <div class="calculator">
    <h2>价格计算器</h2>
    <div class="table-content">
      <div class="nav-tab-pane flex-align-center flex-center">
        <div class="cpu-title table-title " :class="cpuBox ? 'active' : ''" @click="cpuClick">
          CPU渲染成本估算
        </div>
        <div class="shu"></div>
        <div class="gpu-title table-title" :class="!cpuBox ? 'active' : ''" @click="gpuClick">
          GPU渲染成本估算
        </div>
      </div>
      <div class="cpu-gpu cpu-box mt">
        <div class="calculator_sec">
          <div class="calculator_sec_header">
            <h3 class="flex-align-center">
              <font style="vertical-align: inherit;margin-left: 10px">
                <font style="vertical-align: inherit;">渲染量</font>
              </font>
            </h3>
          </div>
          <div class="default_row">
            <el-form :inline="true" :label-position="labelPosition" label-width="90px" :model="form">
              <template>
                <div class="calculator-box">
                  <el-form-item class="calculator-left" label="帧数" >
                    <el-input 
                      type="number" 
                      oninput="value=value.replace(/[^\d]|^[0]/g,'')" 
                      @input="inputChange" 
                      v-model="form.FR">
                    </el-input>
                  </el-form-item>
                  <el-form-item label="渲染时长(分)" class="flex input-box-right">
                    <el-input 
                      class="full-input-width"
                      type="number" 
                      oninput="value=value.replace(/[^\d]|^[0]/g,'')" 
                      @input="inputChange" 
                      v-model="form.Min">
                    </el-input>
                  </el-form-item>
                </div>
              </template>
            </el-form>
          </div>
        </div>
        <div class="calculator_sec">
          <div class="calculator_sec_header">
            <h3 class="flex-align-center">
              <font style="vertical-align: inherit;margin-left: 10px">
                <font style="vertical-align: inherit;">机器配置</font>
              </font>
            </h3>
          </div>
          <div class="default_row">
            <div class="calculator-box" v-show="cpuBox">
              <div class="calculator-left flex-align-center">
                <p class="com-title">品牌</p>
                <el-select
                  popper-class="popdrop"
                  class="com-opt"
                  v-model="selected"
                  filterable
                  remote>
                  <el-option
                    v-for="(item, index) in renderDate"
                    :key="index"
                    :label="item.renderKey"
                    :value="item.renderKey"
                  />
                </el-select>
              </div>
              <div class="select-box flex-align-center">
                <p class="com-title ">型号</p>
                <el-select
                  popper-class="popdrop"
                  class="com-opt com-opt-right"
                  v-model="processor"
                  filterable
                  remote>
                  <el-option
                    v-for="(itemValue, index) in selection"
                    :key="index"
                    :label="itemValue.Processor"
                    :value="itemValue.Processor"/>
                </el-select>
              </div>
            </div>
            <div class="calculator-box" v-show="!cpuBox">
              <div class=" calculator-left flex-align-center">
                <p class="com-title ">型号</p>
                <el-select
                  popper-class="popdrop"
                  class="com-opt"
                  v-model="gpuSecet"
                  filterable
                  remote>
                  <el-option
                    v-for="(item, index) in gpuDate"
                    :key="index"
                    :label="item.graphicsCard"
                    :value="item.graphicsCard"
                  />
                </el-select>
              </div>
              <div class="select-box flex-align-center">
                <p class="com-title">显卡数</p>
                <el-select
                  class="com-opt com-opt-right"
                  popper-class="popdrop"
                  v-model="graphicsNum"
                  @change="changeGrap"
                  filterable
                  remote>
                  <el-option
                    v-for="num in 2"
                    :key="num"
                    :label="num"
                    :value="num"
                  />
                </el-select>
              </div>
            </div>
          </div>
        </div>
        <div class="calculator_sec">
          <div class="calculator_sec_header">
            <h3 class="flex-align-center">
              <font style="vertical-align: inherit;margin-left: 10px">
                <font style="vertical-align: inherit;">渲染农场</font>
              </font>
            </h3>
          </div>
          <div class="default_row last-default_row">
            <el-form :inline="true" :label-position="labelPosition"  label-width="90px" :model="form">
              <template>
                <div class="calculator-box">
                  <el-form-item class="calculator-left" label="机器数">
                    <el-input 
                      type="number" 
                      oninput="value=value.replace(/[^\d]|^[0]/g,'')" 
                      @input="inputChange" 
                      v-model="form.machine">
                    </el-input>
                  </el-form-item>
                </div>
              </template>
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <div class="calculator_sum">
      <div class="cal_bp cal_time flex-center flex-align-center">
        <span class="cal-title mr10">
          <font style="vertical-align: inherit;">
            <font style="vertical-align: inherit;">本地渲染时长:</font>
          </font>
        </span>
        <p class="cal-times">
          <span ng-bind="TotalRP" class="ng-binding">
            <font style="vertical-align: inherit;">
              <font style="vertical-align: inherit;">{{userLocalRenderTimes}}</font>
            </font>
          </span>
        </p>
      </div>
      <div class="cal_bp hidden-xs-only">
        <div class="flex-center flex-align-center">
          <span class="cal-title mr10">
            <font style="vertical-align: inherit;">
              <font style="vertical-align: inherit;">{{form.machine}}台节点渲染时长:</font>
            </font>
          </span>
          <p class="cal-times">
            <span ng-bind="TotalRP" class="ng-binding">
              <font style="vertical-align: inherit;">
                <font style="vertical-align: inherit;">{{rendergRenderTimes}}</font>
              </font>
            </span>
          </p>
        </div>
      </div>
      <div class="cal_sum hidden-xs-only">
        <div class="flex-center flex-align-center">
          <span class="cal-title mr10">
            <font style="vertical-align: inherit;">
              <font style="vertical-align: inherit;">渲染费用:</font>
            </font>
          </span>
          <p class="cal-times">
            <span ng-bind="Total" class="ng-binding">
              <font style="vertical-align: inherit;">
                <font style="vertical-align: inherit;">{{userRenderCost}}</font>
              </font>
            </span>
            <font style="vertical-align: inherit;">
              <font style="vertical-align: inherit;">元</font>
            </font>
          </p>
        </div>
      </div>
      <div class="flex-align-center flex-center hidden-sm-and-up">
        <div class="cal_bp ">
          <div class="flex-center flex-align-center">
            <span class="cal-title mr10">
              <font style="vertical-align: inherit;">
                <font style="vertical-align: inherit;">{{form.machine}}台节点渲染时长:</font>
              </font>
            </span>
            <p class="cal-times">
              <span ng-bind="TotalRP" class="ng-binding">
                <font style="vertical-align: inherit;">
                  <font style="vertical-align: inherit;">{{rendergRenderTimes}}</font>
                </font>
              </span>
            </p>
          </div>
        </div>
        <div class="cal_sum ">
          <div class="flex-center flex-align-center">
            <span class="cal-title mr10">
              <font style="vertical-align: inherit;">
                <font style="vertical-align: inherit;">渲染费用:</font>
              </font>
            </span>
            <p class="cal-times">
              <span ng-bind="Total" class="ng-binding">
                <font style="vertical-align: inherit;">
                  <font style="vertical-align: inherit;">{{userRenderCost}}</font>
                </font>
              </span>
              <font style="vertical-align: inherit;">
                <font style="vertical-align: inherit;">元</font>
              </font>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { renderDate, gpuDate } from "./data"
export default {
  data() {
    return {
      cpuBox: true,
      labelPosition: 'left',
      form: {
        region: '',
        radio: 1,
        FR: 500,
        Min: 1,
        brand: 'AMD',
        machine: 500,
        ghz: 3.7,
        cores: 6,
        CPUSockets: 1
      },
      selected: 'Intel XEON',
      gpuSecet: 'GeForce GTX 1050',
      processor: 'X5698',
      graphicsNum: 1,
      renderDate: [],
      gpuDate: [],
      selectLevel: '钻石会员',
      selectPrice: 2.5,
      levelList: [
        {
          text: '钻石会员',
          price: 1.0
        },
        {
          text: '白金会员',
          price: 1.5
        },
        {
          text: '黄金会员',
          price: 1.8
        },
        {
          text: '白银会员',
          price: 2.0
        },
        {
          text: '普通会员',
          price: 2.5
        },
      ],
      userLocalRenderTimes: '',
      rendergRenderTimes: '0小时7分',
      userRenderCost: '128'
    }
  },
  created() {
    this.renderDate = renderDate
    this.gpuDate = gpuDate
    this.getComputed()
    this.getRenderingData()
  },
  computed: {
    selection: {
      get: function() {
        var that = this;
        return this.renderDate.filter(function(item) {
          return item.renderKey == that.selected;
        })[0].renderValue;
      }
    }
  },
  methods: {
    getComputed () {
      this.processor = this.selection[0].Processor
    },
    cpuClick () {
      this.cpuBox = true
      this.selectPrice = 2.5
      this.getRenderingData()
    },
    gpuClick () {
      this.cpuBox = false
      this.selectPrice = 6
      this.getRenderingData()
    },
    inputChange () {
      if (this.form.FR < 1) {
        this.form.FR = 1
      }
      if (this.form.Min == '' || this.form.Min < 0) {
        this.form.Min = 0
      }
      if (this.form.machine < 1) {
        this.form.machine = 1
      }
     this.getRenderingData()
    },
    levelChange (event) {
      this.selectPrice = event
      this.getRenderingData()
    },
    changeGrap (event) {
      this.graphicsNum = event
      this.getRenderingData()
    },
    getRenderingData () {
      // this.form.FR 帧数  this.form.Min 渲染时长  this.graphicsNum 显卡
      let min = Number(this.form.FR * this.form.Min * this.graphicsNum)
      // 本地渲染时长
      this.userLocalRenderTimes = Math.floor(min / 60) + "小时" + min % 60 + "分"
      // 云渲染时长
      let times = Math.floor(min / this.form.machine)
      let renderTimes = Number(times * 3)
      this.rendergRenderTimes = Math.floor(renderTimes / 60) + "小时" + renderTimes % 60 + "分"
      // 渲染费用
      let costTime = Math.ceil(min / 60)
      this.userRenderCost = Number(costTime * this.selectPrice)
    }
  },
  watch: {
    selected () {
      this.getComputed()
    },
  },
}
</script>